export enum Hash {
    CookiesPolicy = '#cookies-policy',
    DeliveryReturnsModal = '#delivery-returns-modal',
}
